export class User {
    first_name: string;
    last_name: string;
    contact_no: number;
    email_id: string;
    password: string;
    password0: string;
    editUser: string;
    ac_status: boolean;
    user_type: number;
    ocode: string;
    account_type: string;
}
